import React from 'react';
import { useParams } from 'react-router-dom';
import { UpcomingEvents, CalendarDayIcon } from '../../components';

export default function MobileCourseEventsPage(){
  const { courseId } = useParams();
  return (
    <div className="m-screen single-card-screen">
      <h2 className="m-subtitle m-subtitle-with-icon">
        <CalendarDayIcon date={new Date()} size={24} />
        <span>Course Events</span>
      </h2>
      <UpcomingEvents courseEndeavorId={Number(courseId)} />
    </div>
  );
}